
import './OurGuarantee.css';

const OurGuarantee = () => {
  return (
    <div className="guarantee-section">
      
            <div className="guarantee-container" style={{textAlign: 'center'}}>
            <div className='guarantee-banner'>GUARANTEE / WARRANTY</div>
                <p>
                <b>OUR GUARANTEE<br /> </b>As a fully mobile body shop that has been in the business over 7 years, we’re so confident in our craftsmanship and customer service that we offer a bold guarantee: <b>if you’re not completely satisfied with the results, the repair is absolutely free! </b>
                <br />
                <br />
                <b>OUR WARRANTY</b><br />
                All our work comes with a <b>LIFETIME WARRANTY:</b> if you encounter any issues related to the repairs we've performed, simply reach out to us, and we'll promptly correct the issue. If we can't, we will return your money.
                    IT'S THAT SIMPLE!
                Your satisfaction is our priority, and we stand behind every job with integrity.
                <br /><br />

                We take pride in our attention to detail and only use top quality materials. That’s why we confidently back our auto body repair and paint services with a lifetime warranty: to guarantee long-term quality, durability, and peace of mind for our customers. 
                When you choose us, you're not just getting a repair—you're getting lasting value and trusted results.
<br /><br />
              <br /><br />
                <div className='guarantee-text'>
                  <b>Warranty Coverage</b><br />
                  Mobile Dent And Scratch Repair provides a lifetime Limited Warranty on all body and paint work. This warranty covers:<br />
                  <br />
                  
                  <ul style={{listStyleType: "disc", listStylePosition: "inside"}}>
                    <li>
                    <b>Body and paint repairs</b><br />
                  All bodywork and paint refinishing are guaranteed to be free from defects in workmanship and materials for as long as you own the vehicle.
                  
                    </li>
                  
                  <br /><br />
                  <li>
                  <b>Parts Installation</b><br />
                  OEM or equivalent aftermarket parts are covered under the manufacturer’s warranty. We do not warranty parts supplied by the customer.
                  
                  </li>
                 </ul>
                 <br />
                 <b>What Is Not Covered</b><br />
                  This warranty does not cover:
                  <ul style={{listStyleType: "disc", listStylePosition: "inside"}}>
                    <li>
                    Damage caused by misuse, accidents, negligence, or environmental hazards (e.g., acid rain, tree sap, hail)
                    </li>
                    <li>Normal wear and tear, including rock chips, scratches, or rust</li>
                    <li>Repairs not performed by our shop or unauthorized modifications</li>
                    <li>Damage resulting from improper maintenance or failure to follow post-repair care instructions</li>

                    
                  </ul>
                 <br />
                  <b>Limitations</b><br />
                  This warranty is non-transferable and applies only to the original customer named on the invoice. It does not cover loss of use, rental costs, or consequential damages.         
                </div>
                

                   
                </p>
            </div>
        </div>
  )
}

export default OurGuarantee